var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardBankMarks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.732,
    y: 55.525,
    width: 3,
    height: 3,
    rx: 0.5,
    transform: "rotate(15 10.732 55.525)",
    stroke: "#FF3434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5616,
    y: 56.8189,
    width: 3,
    height: 3,
    rx: 0.5,
    transform: "rotate(15 15.5616 56.8189)",
    stroke: "#FF3434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.3912,
    y: 58.1133,
    width: 3,
    height: 3,
    rx: 0.5,
    transform: "rotate(15 20.3912 58.1133)",
    stroke: "#FF3434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25.2207,
    y: 59.4073,
    width: 3,
    height: 3,
    rx: 0.5,
    transform: "rotate(15 25.2207 59.4073)",
    stroke: "#FF3434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 33.9141,
    y: 61.7364,
    width: 3,
    height: 3,
    rx: 0.5,
    transform: "rotate(15 33.9141 61.7364)",
    stroke: "#FF3434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 38.7439,
    y: 63.0308,
    width: 3,
    height: 3,
    rx: 0.5,
    transform: "rotate(15 38.7439 63.0308)",
    stroke: "#FF3434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 43.5735,
    y: 64.3248,
    width: 3,
    height: 3,
    rx: 0.5,
    transform: "rotate(15 43.5735 64.3248)",
    stroke: "#FF3434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 48.4031,
    y: 65.6187,
    width: 3,
    height: 3,
    rx: 0.5,
    transform: "rotate(15 48.4031 65.6187)",
    stroke: "#FF3434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 57.0965,
    y: 67.9483,
    width: 3,
    height: 3,
    rx: 0.5,
    transform: "rotate(15 57.0965 67.9483)",
    stroke: "#FF3434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 61.9261,
    y: 69.2423,
    width: 3,
    height: 3,
    rx: 0.5,
    transform: "rotate(15 61.9261 69.2423)",
    stroke: "#FF3434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 66.7557,
    y: 70.5367,
    width: 3,
    height: 3,
    rx: 0.5,
    transform: "rotate(15 66.7557 70.5367)",
    stroke: "#FF3434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBankMarks);
export default ForwardRef;